import React from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '../icons/Icon';
import { theme } from '../../styles/theme';
import { Currency } from '../../types/currency';
import styles from './LoanTypeSection.module.less';
import { OtcAvailability } from '../../utils/checkOtcAvailability';
import { getOtcAvailabilityMessage } from '../../utils/getOtcAvailabilityMessage';

interface OtcCardProps {
  selected: boolean;
  otcAvailability: OtcAvailability;
  currency: Currency;
  onSelect: () => void;
  isPulsing: boolean;
}

export const OtcCard: React.FC<OtcCardProps> = ({
  selected,
  otcAvailability,
  currency,
  onSelect,
  isPulsing,
}) => {
  const intl = useIntl();

  const isAvailable = otcAvailability.available;

  const handleCardClick = () => {
    if (isAvailable) {
      onSelect();
    }
  };

  const disabledMessage = getOtcAvailabilityMessage(
    otcAvailability,
    currency,
    intl
  );

  const cardClassName = `${styles.loanTypeCard}${!isAvailable ? ` ${styles.disabled}` : ''}${isPulsing ? ` ${styles.pulsing}` : ''}`;
  const checkboxClassName = `${styles.cardCheckbox}${selected ? ` ${styles.checked}` : ''}`;
  const checkmarkClassName = `${styles.checkmarkIcon}${selected ? ` ${styles.visible}` : ''}`;

  return (
    <div
      className={cardClassName}
      onClick={handleCardClick}
      role="button"
      tabIndex={isAvailable ? 0 : -1}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick();
        }
      }}
      aria-disabled={!isAvailable}
    >
      <div className={styles.cardHeader}>
        <div className={checkboxClassName}>
          <span className={checkmarkClassName}>
            <Icon type="checkmark" color={theme.white} />
          </span>
        </div>
        <div className={styles.cardInfo}>
          <div className={styles.cardTitleRow}>
            <div className={styles.cardTitle}>
              {intl.formatMessage({ id: 'loanType.otc.title' })}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cardDescription}>
        {isAvailable
          ? intl.formatMessage({ id: 'loanType.otc.description' })
          : disabledMessage && (
              <span className={styles.unavailableReason}>
                {disabledMessage.content}
              </span>
            )}
      </div>
    </div>
  );
};
